import { formatCloseDate } from '../Deals/components/dealStages';

export const GRANT_STAGE_CONFIG = {
  prospect: { label: 'Prospect', color: 'gray', subtitle: 'Researching fit' },
  drafting: { label: 'Drafting', color: 'blue', subtitle: 'Application in progress' },
  submitted: { label: 'Submitted', color: 'warning', subtitle: 'Awaiting decision' },
  awarded: { label: 'Awarded', color: 'success', subtitle: 'Funded · reporting' },
  complete: { label: 'Complete', color: 'purple', subtitle: 'Final report filed' },
  declined: { label: 'Declined', color: 'error', subtitle: 'Not funded' },
};

export const DOCUMENT_CATEGORY_LABELS = {
  application: 'Application',
  award_letter: 'Award letter',
  report: 'Report',
  supporting: 'Supporting',
};

export const GRANT_STAGES = Object.keys(GRANT_STAGE_CONFIG);

export const BOARD_STAGES = GRANT_STAGES.filter((stage) => stage !== 'complete');

export function grantStageConfig(stage) {
  return GRANT_STAGE_CONFIG[stage] || { label: stage, color: 'gray', subtitle: '' };
}

const MS_PER_DAY = 86400000;

export function daysUntil(dueOn, today = new Date()) {
  if (!dueOn) return null;
  const [year, month, day] = dueOn.substring(0, 10).split('-').map(Number);
  const due = Date.UTC(year, month - 1, day);
  const start = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.round((due - start) / MS_PER_DAY);
}

export function relativeDays(n) {
  if (n === 0) return 'Today';
  if (n === 1) return 'Tomorrow';
  if (n < 0) return `${-n} ${n === -1 ? 'day' : 'days'} overdue`;
  return `in ${n} days`;
}

export function nextDeadlineText(nextDeadline, today = new Date()) {
  if (!nextDeadline) return { dateText: '—', line: 'No open dates' };
  return {
    dateText: formatCloseDate(nextDeadline.due_on),
    line: `${nextDeadline.label} · ${relativeDays(daysUntil(nextDeadline.due_on, today))}`,
  };
}

export function toAmount(value) {
  if (value === null || value === undefined || value === '') return null;
  return Number(value);
}
